import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { api } from '../../api/client';
import { useToast } from '../../context/ToastContext';
import '../../App.css';
import EventForm, { IEventFormData } from '../../components/forms/EventForm';
import { translateError } from '../../utils/errorMessages';

const EventCreatePage: React.FC = () => {
  const { t } = useTranslation();
  const { addToast } = useToast();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  const handleSubmit = async (data: IEventFormData) => {
    setLoading(true);
    setError(null);

    try {
      await api.events.create(data);
      addToast(t('events.createTitle') + ' - ' + t('common.save') + '!', 'success');
      navigate('/admin/events');
    } catch (err: any) {
      const errorMessage = translateError(err, t);
      setError(errorMessage);
      addToast(t('common.error') + ': ' + errorMessage, 'error');
      setLoading(false);
    }
  };

  return (
    <div className="admin-form-page">
      <h2>{t('events.createTitle')}</h2>
      {error && <p className="error-message">{t('common.error')}: {error}</p>}
      <EventForm
        onSubmit={handleSubmit}
        loading={loading}
        submitButtonText={t('events.createButton')}
      />
      <Link to="/admin/events" className="form-link">{t('events.goBack')}</Link>
    </div>
  );
};

export default EventCreatePage;
